import React, { useEffect } from "react";
import "../popup.css";
import SubmitButton from "../../Buttons/SubmitButton";
import CancelButton from "../../Buttons/CancelButton";
import BackButton from "../../Buttons/BackButton";
import { redirectToRealMe } from "../../../Services/apiService";
import ExternalLink from "../../ExternalLink/ExternalLink.tsx";
import RedBack from "../../../assets/images/RedBack.svg";
import { gtmPush } from "../../../analytics/useGtmPageview.tsx";
const NoDocId = ({ onContinue, onCancel, onClose }) => {
  const handleOverlayClick = (e) => {
    // Only trigger cancel if user clicks directly on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    gtmPush("popup_open", {
      popup_id: "no_document_popup",
      popup_name: "No Document ID Popup",
      trigger: "manual",
      page_path: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <h1 className="modal-title">
          We require photo ID or an identity referee
        </h1>

        <p className="modal-text">
          If you cannot provide either of these,{" "}
          <ExternalLink
            href="https://www.realme.govt.nz/contact-us/"
            text="contact us"
          />{" "}
          to discuss your options.
        </p>

        <div className="modal-actions no-doc-id">
          <BackButton text={"Back"} onClick={handleOverlayClick} />
          <CancelButton
            text={"Exit to RealMe"}
            onClick={redirectToRealMe}
            icon={RedBack}
          />
        </div>
      </div>
    </div>
  );
};

export default NoDocId;
